import React from "react";
import { Link } from "react-router-dom";
import { Container, Section } from "@/components/ui-bits/Primitives";

export default function NotFound() {
    return (
        <Section className="min-h-[60vh] flex items-center" data-testid="notfound-page">
            <Container className="text-center">
                <div className="eyebrow mb-4">404</div>
                <h1 className="font-heading text-5xl md:text-7xl text-white tracking-tight">Page not found.</h1>
                <p className="mt-6 text-slate-400 max-w-md mx-auto">The page you're looking for isn't here. Let's get you back to powering EVs.</p>
                <Link to="/" className="btn-primary mt-10 inline-flex">Return Home</Link>
            </Container>
        </Section>
    );
}
